import type { PersonRef } from "@/features/approvals/api/approvals.types";

/**
 * TALEP EDENİN ADI — hesabı artık olmayan kişi için akışın anlık görüntüsünden (onay-zinciri 20 Ekim 2026).
 *
 * Sunucu bir kullanıcı kimliğini ada çevirirken, ne çalışan kaydı ne e-postası bulunamayan hesaba «Bilinmeyen
 * kullanıcı» diyor (`resolvePeople`). Onay yeniden yönlendirilip yeni onaycının kutusuna düşünce o ad «Talep eden»
 * olarak görünüyordu — kutu sahibi kimin izni olduğunu okuyamıyordu. İzin akışı başlarken anlık görüntüye
 * `employeeName` yazıyor (onaycıya giden bildirimin cümlesi için); çözülemeyen kişide o kullanılıyor.
 *
 * «ÇÖZÜLEMEYEN» = ne çalışan kimliği ne e-posta (`PersonRef`'in yedek dalı). Çözülen kişinin adı her zaman önce.
 *
 * SUNUCU ARTIK ÖNCE KENDİ DENİYOR (aynı gün, ikinci tur): talep edenin hesabı gittiyse `resolvePeople` adı kaydın söylediği
 * istihdamdan veriyor (`requesterEmploymentHints`) — anlık görüntüsünde `employeeName` olmayan ESKİ talepler de (Ağustos'ta
 * açılmış bir talep «Bilinmeyen kullanıcı» çıkıyordu). Bu işlev, o düzeltmeyi taşımayan sunucu için yedek.
 */
export function requesterNameOf(
  requester: PersonRef | null | undefined,
  context: Record<string, unknown> | undefined,
): string | null {
  if (requester && (requester.employeeId !== null || requester.email !== null)) {
    return requester.displayName;
  }
  const snapshot = context?.employeeName;
  if (typeof snapshot === "string" && snapshot.trim() !== "") return snapshot.trim();
  return requester?.displayName ?? null;
}
